import { cn } from '~/shadcn/lib/utils'

type Props = {
  disabled?: boolean
  control: React.ReactNode
  label: string
  className?: string
}

function FormControlLabelStyled({
  disabled,
  control,
  label,
  className,
}: Props) {
  return (
    <label
      className={cn(
        'flex items-start gap-2',
        disabled && 'opacity-50 cursor-not-allowed',
        className
      )}>
      {control}
      <span className="text-base text-muted font-semibold leading-normal">
        {label}
      </span>
    </label>
  )
}

export { FormControlLabelStyled }
